import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/yantra-calculator/page.tsx");
